(() => {
  const selector = '[data-vena-faq-drawer]';
  const activeAnimations = new WeakMap();

  function finish(drawer, open) {
    drawer.open = open;
    drawer.classList.remove('is-opening', 'is-closing');
    drawer.style.height = '';
    drawer.style.overflow = '';
    activeAnimations.delete(drawer);
  }

  function animateOpen(drawer) {
    const summary = drawer.querySelector('summary');
    if (!summary) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const startHeight = `${drawer.offsetHeight}px`;
    drawer.open = true;
    drawer.classList.add('is-opening');
    const endHeight = `${drawer.offsetHeight}px`;

    if (reducedMotion) {
      finish(drawer, true);
      return;
    }

    drawer.style.height = startHeight;
    drawer.style.overflow = 'hidden';
    const animation = drawer.animate(
      { height: [startHeight, endHeight] },
      { duration: 310, easing: 'cubic-bezier(.22, .8, .22, 1)' }
    );
    activeAnimations.set(drawer, animation);
    animation.onfinish = () => finish(drawer, true);
    animation.oncancel = () => finish(drawer, true);
  }

  function animateClose(drawer) {
    const summary = drawer.querySelector('summary');
    if (!summary) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const startHeight = `${drawer.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;
    drawer.classList.add('is-closing');

    if (reducedMotion) {
      finish(drawer, false);
      return;
    }

    drawer.style.height = startHeight;
    drawer.style.overflow = 'hidden';
    const animation = drawer.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'cubic-bezier(.4, 0, .2, 1)' }
    );
    activeAnimations.set(drawer, animation);
    animation.onfinish = () => finish(drawer, false);
    animation.oncancel = () => finish(drawer, false);
  }

  function setDrawer(drawer, open) {
    const current = activeAnimations.get(drawer);
    if (current) current.cancel();
    if (open) animateOpen(drawer);
    else animateClose(drawer);
  }

  function initialiseDrawer(drawer) {
    if (drawer.dataset.venaFaqReady === 'true') return;
    const summary = drawer.querySelector('summary');
    const list = drawer.closest('[data-vena-faq-list]');
    if (!summary || !list) return;

    drawer.dataset.venaFaqReady = 'true';
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = !drawer.open;

      if (willOpen) {
        list.querySelectorAll(selector).forEach((otherDrawer) => {
          if (otherDrawer !== drawer && otherDrawer.open) setDrawer(otherDrawer, false);
        });
      }

      setDrawer(drawer, willOpen);
    });
  }

  function initialise(scope = document) {
    const drawers = scope.matches?.(selector) ? [scope] : scope.querySelectorAll(selector);
    drawers.forEach(initialiseDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
